import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './plugins/i18n';
import amplify from './plugins/amplify';
import session from './plugins/session';
import hotjar from './plugins/hotjar';

import 'tailwindcss/tailwind.css';
import 'intl-tel-input/build/css/intlTelInput.css';

createApp(App)
  .use(store)
  .use(router)
  .use(session)
  .use(amplify)
  .use(i18n)
  .use(hotjar)
  .mount('#app');
